import { css } from '@emotion/css';
import { rgba } from '@miotech/picasso';
import { light } from './light';

const branding = '#0090B0';

const THEME = {
  ...light,
  branding,
  branding_10: rgba(branding, 0.1),
  branding_120: '#059B66',
  pending: '#FFBE3D',
  // 非 prism 定义的color
  warning: '#FF6336',
  green: '#9BC655',
  orange: '#FF6336',
  darkGreen: '#00AE70',
  lightGreen: '#0CD68D',
  overlayGreen: '#5A7B6F',
};

export default THEME;

export const primaryLightGrey = '#262A2F';
export const themeBorderGrey = '#ebebeb';
export const secondaryColor = '#9C9C9C';
export const borderGrey = '#D8D8D8';
export const themeBGColor = '#F2F6F6';
export const themeWhite = '#ffffff';
export const themeBlack = '#111';
export const darkGreen = '#00AE70';
export const lightGreen = '#0CD68D';
export const rejectColor = '#ff6336';
export const backgroundLight = '#F9F9F9';

export const styleColor = (color: keyof typeof THEME) => css`
  color: ${THEME[color]};
`;
